import React from 'react';
import ReactDOM from 'react-dom';
import Router from './Router';
if (document.getElementById('app')) {
    ReactDOM.render(<Router />, document.getElementById('app'));
}